/* istanbul ignore file */
export * from './FilterSettingsMobile';
